import * as React from "react";
import { forwardRef } from "react";
const SvgHelp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 17.125V17.075M12 14.625C12 11.565 15 12.98 15 9.9206C15 5.8598 9 5.8598 9 9.9206", stroke: "#5A6367", strokeWidth: 1.44, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 9.28, stroke: "#5A6367", strokeWidth: 1.44 }));
const ForwardRef = forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
